/*
 * Abstract class Software
 */
export default class Software {
    constructor($sce, $content, $deviceDisplayCount) {
        this.software = this.deviceDisplayType($deviceDisplayCount);
    }

    deviceDisplayType($deviceDisplayCount) {
        var devices = {
            'pc'        : [],
            'mac'       : [],
            'mobile'    : []
        };

        for (var device in devices) {
            var icon_screen = (device == 'pc' || device == 'mac') ? 'flaticon-laptop-1' : 'flaticon-smartphone-1';

            if ($deviceDisplayCount > 3) {
                for (var i = 0; i < 2; i++) {
                    devices[device].push({
                        icon_screen     : icon_screen,
                        icon_locked     : 'fa fa-lock',
                        icon_unlocked   : 'fa fa-unlock-alt',
                        device_name     : '',
                        installs        : 0
                    });
                }
            } else {
                for (var i = 0; i < 3; i++) {
                    devices[device].push({
                        icon_screen: icon_screen,
                        icon_locked: 'fa fa-lock',
                        icon_unlocked: 'fa fa-unlock-alt',
                        device_name: '',
                        protected: false
                    });
                }
            }
        }

        return devices;
    }

    setProtectedSoftware(device_type) {
        var data = {
            pc : {
                title 			: this.content['download-pc-images-title'],
                available		: parseInt(this.software.pc.length),
                device			: this.software.pc,
                display 		: false,
                copy 			: this.$sce.trustAsHtml(this.getDownloadData('pc'))
            },
            mac : {
                title 			: this.content['download-pc-images-title'],
                available		: parseInt(this.software.mac.length),
                device			: this.software.mac,
                display 		: false,
                copy 			: this.$sce.trustAsHtml(this.getDownloadData('pc'))
            },
            mobile : {
                title 			: this.content['download-mobile-images-title'],
                available		: parseInt(this.software.mobile.length),
                device 			: this.software.mobile,
                display			: false,
                copy 			: this.$sce.trustAsHtml(this.getDownloadData('mobile'))
            }
        };

        for (var i in data) {
            if (i == device_type) {
                data[i].display = true;
            }

            for (var a in this.software[i]) {
                if (this.software[i][a].protected) {
                    data[i].available -= 1;
                }
            }
        }

        return data;
    }
};
